import { render, staticRenderFns } from "./prePayFeeDetail.vue?vue&type=template&id=4e8cb58e&scoped=true"
import script from "./prePayFeeDetail.vue?vue&type=script&lang=js"
export * from "./prePayFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./prePayFeeDetail.vue?vue&type=style&index=0&id=4e8cb58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8cb58e",
  null
  
)

export default component.exports